'use strict';

var webutil = require('./');

var PAGE_GROUP_PREFIX = 'main:bankingbundle:';

var PAGE_GROUP_UPGRADE = PAGE_GROUP_PREFIX + 'upgrade:';
var PAGE_GROUP_UPGRADE_CIP_STATUS = PAGE_GROUP_PREFIX + 'UPGRADE_TYPE:CIP_STATUS';
var PAGE_GROUP_UPGRADE_BUSINESS = PAGE_GROUP_PREFIX + 'upgrade:business';
var PAGE_GROUP_ACTIVATE_CARD = PAGE_GROUP_PREFIX + 'activatecard:';
var PAGE_GROUP_MANAGE_CARD = PAGE_GROUP_PREFIX + 'managecard:';
var PAGE_GROUP_REPLACE_CARD = PAGE_GROUP_PREFIX + 'replaceCard:REPLACE_CARD_REASON';
var PAGE_GROUP_PPCASH = PAGE_GROUP_PREFIX + 'ppcash:';
var PAGE_GROUP_PRODUCT_ELIGIBILITY = PAGE_GROUP_PREFIX + 'prodeligibility:';
var PAGE_GROUP_COMMON = PAGE_GROUP_PREFIX + ':';

var PAGE_GROUP_MANAGE_CARD_UPDATE_PIN = PAGE_GROUP_MANAGE_CARD + 'updatepin';
var PAGE_GROUP_MANGE_CARD_CHANGE_BILLING = PAGE_GROUP_MANAGE_CARD + 'changebilladdr';
var PAGE_GROUP_MANAGE_CARD_REPORT_CARD = PAGE_GROUP_MANAGE_CARD + 'reportcard';
var PAGE_GROUP_MANAGE_CARD_CANCEL_CARD = PAGE_GROUP_MANAGE_CARD + 'cancelcard';
var PAGE_GROUP_MANAGE_CARD_DAMAGED_CARD = PAGE_GROUP_MANAGE_CARD + 'damagedcard';
var PAGE_GROUP_MANAGE_CARD_LOW_BALANCE = PAGE_GROUP_MANAGE_CARD + 'lowbalance';
var PAGE_GROUP_MANAGE_CARD_MANUAL_TOPUP = PAGE_GROUP_MANAGE_CARD + 'manualtopup';

var fptiMetaConfig = {
    upgradeBundle: {
        // With and without CIP verification page
        upgradeBundleEntry: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'entry'
        },
        upgradeBundleConfirmBillingAddress: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'confirmbilladdr'
        },
        upgradeBundleConfirmShippingAddress: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'confirmshipaddr'
        },
        upgradeBundleSelectBillingAddress: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'selectbilladdr'
        },
        upgradeBundleSelectShippingAddress: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'selectshipaddr'
        },
        upgradeBundleAddAddressForm: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'addaddrform'
        },
        upgradeBundleEditAddressForm: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'editaddrform'
        },
        upgradeBundleNormalizeAddress: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'normalizeaddr',
            isXHR: true
        },
        upgradeBundleNormalizedAddress: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'normalizedaddr'
        },
        upgradeBundleInvalidAddress: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'invalidaddr'
        },
        upgradeBundleConfirmNewAddress: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'confirmnewaddr'
        },
        upgradeBundleAddAddress: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'addaddr',
            isXHR: true
        },
        upgradeBundleCIPForm: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'cipform'
        },
        upgradeBundleUpgrade: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'upgrade',
            isXHR: true
        },
        upgradeBundleResumeUpgrade: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'resumeupgrade'
        },
        upgradeBundleSuccess: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'upgradesuccess'
        },
        upgradeBundleError: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'upgradeerror'
        },
        upgradeBundleLearnMore: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'learnmore'
        },
        upgradeBundleSuccessGoal: {
            pageGroup: PAGE_GROUP_UPGRADE_CIP_STATUS,
            pageContent: 'upgradesuccessgoal'
        }
    },
    upgradeBundleCommon: {
        businessUpgrade: {
            pageGroup: PAGE_GROUP_UPGRADE_BUSINESS,
            pageContent: 'businessupgrade'
        },
        confirmBusinessUpgrade: {
            pageGroup: PAGE_GROUP_UPGRADE_BUSINESS,
            pageContent: 'confirmbusinessupgrade'
        },
        // Manual Review Success
        upgradeManualReviewSuccess: {
            pageGroup: PAGE_GROUP_UPGRADE,
            pageContent: 'mreviewsuccess'
        },
        // Similar Product exists
        similarProductKeepMyCardLink: {
            pageGroup: PAGE_GROUP_UPGRADE,
            pageContent: 'similarproductkeepmycardlink'
        },
        similarProductCloseCardForm: {
            pageGroup: PAGE_GROUP_UPGRADE,
            pageContent: 'similarproductclosecardform'
        },
        similarProductCloseCard: {
            pageGroup: PAGE_GROUP_UPGRADE,
            pageContent: 'similarproductclosecard'
        },
        similarProductCloseCardError: {
            pageGroup: PAGE_GROUP_UPGRADE,
            pageContent: 'similarproductclosecarderror'
        },
        similarProductCloseCardSuccess: {
            pageGroup: PAGE_GROUP_UPGRADE,
            pageContent: 'similarproductclosecardsuccess'
        }
    },
    activateCard: {
        activateCardEntryNotShipped: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'entrycardnotshipped'
        },
        activateCardEntryArrived: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'entrycardarrived'
        },
        activateCardForm: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'activatecardform'
        },
        activateCard: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'activatecard',
            isXHR: true
        },
        activateCardSuccess: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'activatesuccess'
        },
        activateCardNotifySettings: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'updatenotifysettings',
            isXHR: true
        },
        activateCardError: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'activateerror'
        },
        createPinForm: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'createpinform'
        },
        createPin: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'createpin',
            isXHR: true
        },
        createPinSuccess: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'createpinsuccess'
        },
        createPinError: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'createpinerror'
        },
        noCardReceived: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'nocardreceived'
        },
        activateAddMoney: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'activateaddmoney'
        },
        activateCardSuccessMTopup: {
            pageGroup: PAGE_GROUP_ACTIVATE_CARD,
            pageContent: 'activatesuccessmtopup'
        }
    },
    manageCard: {
        manageCardEntry: {
            pageGroup: PAGE_GROUP_MANAGE_CARD,
            pageContent: 'entry'
        },
        manageCardView: {
            pageGroup: PAGE_GROUP_MANAGE_CARD,
            pageContent: 'managecard'
        },
        manageCardFaq: {
            pageGroup: PAGE_GROUP_MANAGE_CARD,
            pageContent: 'faq'
        },
        updatePinForm: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_UPDATE_PIN,
            pageContent: 'updatepinform'
        },
        updatePin: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_UPDATE_PIN,
            pageContent: 'updatepin',
            isXHR: true
        },
        updatePinError: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_UPDATE_PIN,
            pageContent: 'updatepinerror'
        },
        changeBillingSelectAddress: {
            pageGroup: PAGE_GROUP_MANGE_CARD_CHANGE_BILLING,
            pageContent: 'selectaddr'
        },
        changeBilling: {
            pageGroup: PAGE_GROUP_MANGE_CARD_CHANGE_BILLING,
            pageContent: 'changebill',
            isXHR: true
        },
        changeBillingError: {
            pageGroup: PAGE_GROUP_MANGE_CARD_CHANGE_BILLING,
            pageContent: 'changebillerror'
        },
        changeBillingAddAddressForm: {
            pageGroup: PAGE_GROUP_MANGE_CARD_CHANGE_BILLING,
            pageContent: 'addaddrform'
        },
        changeBillingAddAddress: {
            pageGroup: PAGE_GROUP_MANGE_CARD_CHANGE_BILLING,
            pageContent: 'addaddr',
            isXHR: true
        },
        changeBillingNormalizeAddress: {
            pageGroup: PAGE_GROUP_MANGE_CARD_CHANGE_BILLING,
            pageContent: 'normalizeaddr',
            isXHR: true
        },
        changeBillingNormalizedAddress: {
            pageGroup: PAGE_GROUP_MANGE_CARD_CHANGE_BILLING,
            pageContent: 'normalizedaddr'
        },
        changeBillingInvalidAddress: {
            pageGroup: PAGE_GROUP_MANGE_CARD_CHANGE_BILLING,
            pageContent: 'invalidaddr'
        },
        reportCardForm: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_REPORT_CARD,
            pageContent: 'reportcardform'
        },
        reportCard: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_REPORT_CARD,
            pageContent: 'reportcard',
            isXHR: true
        },
        reportCardSuccess: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_REPORT_CARD,
            pageContent: 'reportcardsuccess'
        },
        reportCardError: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_REPORT_CARD,
            pageContent: 'reportcarderror'
        },
        reportCardSelectAddress: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_REPORT_CARD,
            pageContent: 'selectaddr'
        },
        reportCardAddAddressForm: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_REPORT_CARD,
            pageContent: 'addaddrform'
        },
        reportCardAddAddress: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_REPORT_CARD,
            pageContent: 'addaddr',
            isXHR: true
        },
        reportCardNormalizeAddress: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_REPORT_CARD,
            pageContent: 'normalizeaddr',
            isXHR: true
        },
        reportCardNormalizedAddress: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_REPORT_CARD,
            pageContent: 'normalizedaddr'
        },
        reportCardInvalidAddress: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_REPORT_CARD,
            pageContent: 'invalidaddr'
        },
        cancelCardForm: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_CANCEL_CARD,
            pageContent: 'cancelcardform'
        },
        cancelCard: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_CANCEL_CARD,
            pageContent: 'cancelcard',
            isXHR: true
        },
        cancelCardSuccess: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_CANCEL_CARD,
            pageContent: 'cancelcardsuccess'
        },
        cancelCardError: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_CANCEL_CARD,
            pageContent: 'cancelcarderror'
        },
        cashBackEnrolled: {
            pageGroup: PAGE_GROUP_MANAGE_CARD,
            pageContent: 'cashbackenroll'
        },
        cashBackUnEnrolled: {
            pageGroup: PAGE_GROUP_MANAGE_CARD,
            pageContent: 'cashbackunenroll'
        },
        manageCardNotifySettings: {
            pageGroup: PAGE_GROUP_MANAGE_CARD,
            pageContent: 'updatenotifysettings',
            isXHR: true
        },
        selectReplaceCardForm: {
            pageGroup: PAGE_GROUP_MANAGE_CARD,
            pageContent: 'selectreplacecardform'
        },
        damagedCardForm: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_DAMAGED_CARD,
            pageContent: 'damagedcardform'
        },
        damagedCard: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_DAMAGED_CARD,
            pageContent: 'damagedcard',
            isXHR: true
        },
        damagedCardSuccess: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_DAMAGED_CARD,
            pageContent: 'damagedcardsuccess'
        },
        damagedardError: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_DAMAGED_CARD,
            pageContent: 'damagedcarderror'
        },
        damagedCardSelectAddress: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_DAMAGED_CARD,
            pageContent: 'selectaddr'
        },
        damagedCardAddAddressForm: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_DAMAGED_CARD,
            pageContent: 'addaddrform'
        },
        damagedCardAddAddress: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_DAMAGED_CARD,
            pageContent: 'addaddr',
            isXHR: true
        },
        damagedCardNormalizeAddress: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_DAMAGED_CARD,
            pageContent: 'normalizeaddr',
            isXHR: true
        },
        damagedCardNormalizedAddress: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_DAMAGED_CARD,
            pageContent: 'normalizedaddr'
        },
        damagedCardInvalidAddress: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_DAMAGED_CARD,
            pageContent: 'invalidaddr'
        },
        lowBalanceForm: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_LOW_BALANCE,
            pageContent: 'lowbalanceform'
        },
        lowBalance: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_LOW_BALANCE,
            pageContent: 'lowblance',
            isXHR: true
        },
        manualTopup: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_MANUAL_TOPUP,
            pageContent: 'manualtopup'
        },
        manualTopupSelectFundingOption: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_MANUAL_TOPUP,
            pageContent: 'manualtopupselectfundingoption'
        },
        manualTopupSuccess: {
            pageGroup: PAGE_GROUP_MANAGE_CARD_MANUAL_TOPUP,
            pageContent: 'manualtopupsuccess'
        }
    },

    replaceCard: {
        replaceCard: {
            pageGroup: PAGE_GROUP_REPLACE_CARD,
            pageContent: 'replacecard'
        },
        replaceCardConfirmShippingAddress: {
            pageGroup: PAGE_GROUP_REPLACE_CARD,
            pageContent: 'confirmshipaddr'
        },
        replaceCardAddAddressForm: {
            pageGroup: PAGE_GROUP_REPLACE_CARD,
            pageContent: 'addaddrform'
        },
        replaceCardEditAddressForm: {
            pageGroup: PAGE_GROUP_REPLACE_CARD,
            pageContent: 'editaddrform'
        },
        replaceCardNormalizeAddress: {
            pageGroup: PAGE_GROUP_REPLACE_CARD,
            pageContent: 'normalizeaddr',
            isXHR: true
        },
        replaceCardNormalizedAddress: {
            pageGroup: PAGE_GROUP_REPLACE_CARD,
            pageContent: 'normalizedaddr'
        },
        replaceCardAddAddress: {
            pageGroup: PAGE_GROUP_REPLACE_CARD,
            pageContent: 'addaddr',
            isXHR: true
        },
        replaceCardInvalidAddress: {
            pageGroup: PAGE_GROUP_REPLACE_CARD,
            pageContent: 'invalidaddr'
        },
        replaceCardSuccess: {
            pageGroup: PAGE_GROUP_REPLACE_CARD,
            pageContent: 'success'
        },
        replaceCardError: {
            pageGroup: PAGE_GROUP_REPLACE_CARD,
            pageContent: 'error'
        }
    },

    productEligibility: {
        prodEligConfirmNameAddr: {
            pageGroup: PAGE_GROUP_PRODUCT_ELIGIBILITY,
            pageContent: 'confirmnameaddr'
        },
        prodEligCIPForm: {
            pageGroup: PAGE_GROUP_PRODUCT_ELIGIBILITY,
            pageContent: 'cipform'
        },
        prodEligError: {
            pageGroup: PAGE_GROUP_PRODUCT_ELIGIBILITY,
            pageContent: 'producteligibilityerror'
        },
        prodEligCheck: {
            pageGroup: PAGE_GROUP_PRODUCT_ELIGIBILITY,
            pageContent: 'prodeligcheck',
            isXHR: true
        }
    },

    commonPages: {
        directDepositForm: {
            pageGroup: PAGE_GROUP_COMMON,
            pageContent: 'directdeposit'
        },
        directDepositTaxRefund: {
            pageGroup: PAGE_GROUP_COMMON,
            pageContent: 'directdeposittaxrefund'
        },
        addMoney: {
            pageGroup: PAGE_GROUP_COMMON,
            pageContent: 'addmoney'
        },
        terms: {
            pageGroup: PAGE_GROUP_COMMON,
            pageContent: 'terms'
        },
        closeAccount: {
            pageGroup: PAGE_GROUP_COMMON,
            pageContent: 'closeaccount'
        },
        fees: {
            pageGroup: PAGE_GROUP_COMMON,
            pageContent: 'fees'
        },
        error: {
            pageGroup: PAGE_GROUP_COMMON,
            pageContent: 'error'
        },
        stepUpRedirect: {
            pageGroup: PAGE_GROUP_COMMON,
            pageContent: 'stepupredirect'
        },
        ppCashAbout: {
            pageGroup: PAGE_GROUP_PPCASH,
            pageContent: 'about'
        },
        ppCashReload: {
            pageGroup: PAGE_GROUP_PPCASH,
            pageContent: 'reload'
        }
    }
};

exports.fptiMetaConfig = fptiMetaConfig;

exports.getFPTIMeta = function (options) {
    var id = options.id;
    var meta;

    // TODO To replace with Object.keys
    meta = fptiMetaConfig.commonPages[id] || fptiMetaConfig.manageCard[id] ||
        fptiMetaConfig.upgradeBundle[id] || fptiMetaConfig.upgradeBundleCommon[id] ||
        fptiMetaConfig.activateCard[id] || fptiMetaConfig.replaceCard[id] ||
        fptiMetaConfig.productEligibility[id];

    if (!meta && webutil.isDebug()) {
        throw new Error('FPTI metadata not found for ' + options.id);
    }

    return meta;
};



// WEBPACK FOOTER //
// ./public/js/utils/PageNameIdentifiers.js